const agencies = [
    {
        name: "alliance_for_workplace_development",
		text: "Alliance for Workplace Development"
    } ,
    {
        name: "butte_211", 
        text: "Butte 211"
    },
    {
        name: "caring_choices", 
        text: "Caring Choices"
    },
    {
        name: "chip", 
        text: "CHIP"
    },
    {
        name: "dess", 
        text: "DESS"
    },
    {
        name: "fema", 
        text: "FEMA"
    },
    {
		name: "habitat_for_humanity", 
        text: "Habitat for Humanity"
    },
    {
		name: "jesus_center", 
        text: "Jesus Center"
    },
    {
		name: "lsnc", 
        text: "LSNC"
    },
    {
		name: "ltrg_unmet_needs", 
        text: "LTRG Unmet Needs"
    },
    {
		name: "nvcss", 
        text: "NVCSS"
    },
    {
		name: "policy_holders_united", 
        text: "Policy Holders United"
    },
    {
		name: "red_cross", 
        text: "Red Cross"
    },
    {
		name: "salvation_army", 
        text: "Salvation Army"
    },
    {
		name: "st_vincent_de_paul", 
        text: "St. Vincent de Paul"
    },
    {
		name: "torres_shelter", 
        text: "Torres Shelter"
    },
    {
		name: "tzu_chi", 
        text: "Tzu Chi"
    },
    {
		name: "vet_center", 
        text: "Vet Center"
    },
    {
		name: "youth_for_change", 
        text: "Youth for Change"
    }
]

export default agencies;